var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectricalServices = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 11c-1.1 0-2 .9-2 2s.9 2 2 2h2v2H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.5c.83 0 1.5-.67 1.5-1.5S9.33 6 8.5 6H5c-.55 0-1-.45-1-1s.45-1 1-1h3.5C10.43 4 12 5.57 12 7.5S10.43 11 8.5 11H7Zm5 3h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2Zm8-1c.55 0 1 .45 1 1s-.45 1-1 1h-2v-2h2Zm-2 4h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v-2Z",
  fill: "#1A1A1A"
})));
export default SvgElectricalServices;